// const BASE_URL = "https://localhost:7231/api/Employee";


import { BASE_URL } from "../config";

export const getAllEmployees = async () => {
  try {
    const response = await fetch(`${BASE_URL}/Employee/employees`);
    if (!response.ok) {
      throw new Error("Failed to fetch employees");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching employees:", error);
    throw error;
  }
};


export const addEmployee = async (employeeData) => {
  try {
    const response = await fetch(`${BASE_URL}/Employee/addemployee`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(employeeData)
    });

    const result = await response.json(); 
    if (!response.ok) {
      throw new Error(result.message || "Failed to add employee");
    }

    // return await response.json(); 
    // const result = await response.text();
    console.log("Success:", result);
    return result;

  } catch (error) {
    console.error("Error adding employee:", error);
    throw error;
  }
};

export const getEmployeeById = async (employeeId) => {
  try {
    const response = await fetch(`${BASE_URL}/Employee/${employeeId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch employee with ID: ${employeeId}`);
    }

    const data = await response.json();
    console.log("Fetched Employee:", data);
    return data;

  } catch (error) {
    console.error("Error fetching employee:", error);
    throw error;
  }
};

// updateEmployee

export const updateEmployee = async (employeeId, updatedData) => {
  console.log("Updated Employee: ", updatedData.employeeID, employeeId);
  try {
    const response = await fetch(`${BASE_URL}/Employee/editemployee/${employeeId}`, {
      method: "PUT", // or "PATCH" if your API supports partial updates
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(updatedData)
    });

    if (!response.ok) {
      throw new Error(`Failed to update employee with ID: ${employeeId}`);
    }

    // const data = await response.json();
    const data = await response.text();
    console.log("Updated Employee:", data);
    return data;

  } catch (error) {
    console.error("Error updating employee:", error);
    throw error;
  }
};



export const addEmployeeExcel = async (employees) => {
  try {
    const response = await fetch(`${BASE_URL}/Employee/bulk-insert`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(employees),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw errorData;
    }

    return await response.json();
  } catch (error) {
    console.error("Error uploading employees:", error);
    throw error;
  }
};



// /{year}

export const getEmployeesWithoutLeave = async (year) => {
  try {
    const response = await fetch(`${BASE_URL}/Employee/GetEmployeesWithoutLeave/${year}`);
     if (response.status === 404) {
      // API says "no employees found"
      return [];
    }

    if (!response.ok) {
      throw new Error("Failed to get employees");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching employees:", error);
     return [];
  }
};



export const getEmployeeProfile = async (employeeCode) => {
  try {
    const response = await fetch(`${BASE_URL}/Employee/profile/${employeeCode}`);
    if (!response.ok) {
      throw new Error("Failed to get profile");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw error;
  }
};


export const uploadEmployeeDocument = async (formData) => {
  try {
    const response = await fetch(`${BASE_URL}/employee/upload-document`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (response.ok) {
      return { success: true, message: data.Message || data.message || "File uploaded successfully!" };
    } else {
      return { success: false, message: data.Error || data.error || "Fail uploading file." };
    }
  } catch (error) {
    console.error("Upload error:", error);
    return { success: false, message: "Network or server error while uploading." };
  }
};

export const getEmployeeDocuments = async(employeeCode) => {
try {
    const response = await fetch(`${BASE_URL}/Employee/byCode/${employeeCode}`);
    if (!response.ok) {
      throw new Error("Failed to get document");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching document:", error);
    throw error;
  }
};

// export const getFrom16 = async(employeeCode, financialYear) => {
//   try {
//       const response = await fetch(`${BASE_URL}/Employee/form16?employeeCode=${employeeCode}&financialYear=${financialYear}`)
//       console.log("🧾 Raw Response:", response);

//       if (!response.ok) {
//         throw new Error("Failed to get From 16");
//       }
//       return await response.json();
//   }catch (error) {
//       console.error("Error fetching From 16:", error);
//       throw error;
//   }
// };



export const getFrom16 = async (employeeCode, financialYear) => {
  try {
      console.log(`financialYear Year: ${financialYear}`);

    const response = await fetch(
      `${BASE_URL}/Employee/form16?employeeCode=${employeeCode}&financialYear=${financialYear}`
    );

    if (!response.ok) {
      // Read the backend response (it should have { message: "..." })
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Something went wrong while fetching Form16");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching Form16:", error.message);
    throw error; // Rethrow so UI can catch and display it
  }
};
